export const actionTypes = {
    GET_ASSET_HISTOGRAM_KPIS_V2: 'operationalParameters_v2/GET_ASSET_HISTOGRAM_KPIS_V2',
    GET_HISTOGRAM_V2: 'operationalParameters_v2/GET_HISTOGRAM_V2',
    SET_HISTOGRAM_KPI_V2: 'operationalParameters_v2/SET_HISTOGRAM_KPI_V2',
    REMOVE_TREND_KPI_SELECTION_LEGEND_HISTOGRAM_V2: 'operationalParameters_v2/REMOVE_TREND_KPI_SELECTION_LEGEND_HISTOGRAM_V2',
};


export const labelBounds = {
    Both: 'Both',
    LowerThanUpper: 'LowerThanUpper',
    GreaterThanLower: 'GreaterThanLower'
};
